import { ComplexEnum } from '../../../utils/complexEnum'
import { CAS, CTS, DS, FDC } from './instances'

export type CustomFieldEntityItem =
  | typeof DS
  | typeof CAS
  | typeof FDC
  | typeof CTS
type ID = CustomFieldEntityItem['id']
type Type = CustomFieldEntityItem['type']
type ClassType = CustomFieldEntityItem['classType']
class CustomFieldEntityEnum extends ComplexEnum<
  'CustomFieldEntity',
  CustomFieldEntityItem,
  ID
> {
  readonly typename = 'CustomFieldEntity'
  get values() {
    return [this.DS, this.CAS, this.FDC, this.CTS]
  }
  DS = DS
  CAS = CAS
  FDC = FDC
  CTS = CTS
  fromClassType(classType: string) {
    return this.find((value) => value.classType === classType)
  }
  fromClassTypeOrFail(classType: ClassType | string) {
    return this.orFail(this.fromClassType(classType), classType)
  }
  fromType(type: string) {
    return this.find((value) => value.type === type)
  }
  fromTypeOrFail(type: Type | string) {
    return this.orFail(this.fromType(type), type)
  }
}

export const CustomFieldEntity = new CustomFieldEntityEnum()
